import React, { Children } from 'react';
import { motion } from 'framer-motion';
export function ProductRevealSection() {
  const fadeUp = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <section className="py-12 px-5 bg-sage text-white overflow-hidden relative" data-id="element-131">
      <div className="absolute top-0 right-0 w-96 h-96 bg-sage-light rounded-full blur-3xl opacity-30 -translate-y-1/2 translate-x-1/3" data-id="element-132"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-sage-dark rounded-full blur-3xl opacity-30 translate-y-1/3 -translate-x-1/3" data-id="element-133"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-134">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={{
        visible: {
          transition: {
            staggerChildren: 0.2
          }
        }
      }} className="text-center" data-id="element-135">
          <motion.p variants={fadeUp} className="text-white font-semibold tracking-widest uppercase text-lg md:text-xl mb-4" data-id="element-136">
            Introducing
          </motion.p>

          <motion.h2 variants={fadeUp} className="font-serif text-3xl md:text-5xl lg:text-6xl mb-6 leading-tight text-[#FAF8F5]" data-id="element-137">
            The Nervous System Reset for Overstimulated Women
          </motion.h2>

          <motion.p variants={fadeUp} className="text-lg md:text-xl text-white mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-138">
            A science-backed system designed to bring your body out of survival
            mode…
            <br data-id="element-139" />
            <br data-id="element-140" />
            <span className="font-semibold text-white" data-id="element-141">
              In minutes. Not weeks. Not months. Minutes.
            </span>
          </motion.p>
        </motion.div>

        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={{
        visible: {
          transition: {
            staggerChildren: 0.2
          }
        }
      }} className="bg-white/10 backdrop-blur-md rounded-2xl p-6 md:p-10 border border-white/20 text-left" data-id="element-142">
          <motion.h3 variants={fadeUp} className="font-serif text-2xl md:text-3xl mb-5 text-white" data-id="element-143">
            The 5-Minute "Override Switch"
          </motion.h3>

          <motion.p variants={fadeUp} className="text-base text-white mb-5" data-id="element-144">
            At the core of this system:
          </motion.p>

          <motion.div variants={fadeUp} className="bg-white text-charcoal p-5 rounded-xl mb-6 shadow-lg" data-id="element-145">
            <p className="text-base font-medium" data-id="element-146">
              A repeatable, physiological reset that interrupts the survival
              loop in real time.
            </p>
          </motion.div>

          <motion.p variants={fadeUp} className="text-base text-white mb-6" data-id="element-147">
            No guessing. No long routines. No waiting.
            <br data-id="element-148" />
            <br data-id="element-149" />
            Just a simple 5-minute sequence that signals safety to your body…
            <br data-id="element-150" />
            So it can finally stop overreacting.
          </motion.p>

          <motion.div variants={fadeUp} className="pt-6 border-t border-white/20" data-id="element-151">
            <h4 className="font-serif text-2xl mb-4 text-white" data-id="element-152">
              Why This Works
            </h4>
            <p className="text-base text-white mb-4" data-id="element-153">
              Because this doesn't try to manage your stress.
            </p>
            <p className="text-lg font-medium mb-6 text-white" data-id="element-154">
              It resets the system creating it.
            </p>

            <ul className="space-y-3 text-base text-white mb-6" data-id="element-155">
              <li className="flex items-start gap-3" data-id="element-156">
                <span className="text-white/60 mt-1" data-id="element-157">•</span>
                <span data-id="element-158">Instead of forcing calm… you trigger it</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-159">
                <span className="text-white/60 mt-1" data-id="element-160">•</span>
                <span data-id="element-161">Instead of fighting your body… you work with it</span>
              </li>
            </ul>

            <div className="bg-sage-dark/50 p-5 rounded-xl inline-block" data-id="element-162">
              <p className="text-xs text-white/70 uppercase tracking-wider font-semibold mb-1" data-id="element-163">
                Result?
              </p>
              <p className="text-lg font-serif text-white" data-id="element-164">
                Relief that feels immediate.
              </p>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}